import React from "react";

export const PokemonMessage = ({ isMobile }) => {
  return (
    <div className="message-box">
      {isMobile ? (
        <p>
          {" "}
          Hey! Feel free to contact me if you have any questions! Just, Keep
          scrolling 👇
        </p>
      ) : (
        <p>
          Hey! Feel free to contact me if you have any questions! Fill next
          form, please!
        </p>
      )}
    </div>
  );
};

export default PokemonMessage;
